import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-housesimple",
  "use": "icon-th-housesimple-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-housesimple\">\n<path d=\"M27.3538 12.9712L17.3538 3.5362C17.3489 3.53193 17.3443 3.52734 17.34 3.52245C16.9718 3.18762 16.492 3.00208 15.9944 3.00208C15.4967 3.00208 15.0169 3.18762 14.6488 3.52245L14.635 3.5362L4.64625 12.9712C4.4425 13.1586 4.27985 13.3862 4.16861 13.6396C4.05737 13.8931 3.99996 14.1669 4 14.4437V25.9999C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7892 5.46957 27.9999 6 27.9999H26C26.5304 27.9999 27.0391 27.7892 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 25.9999V14.4437C28 14.1669 27.9426 13.8931 27.8314 13.6396C27.7201 13.3862 27.5575 13.1586 27.3538 12.9712ZM26 25.9999H6V14.4437L6.01375 14.4312L16 4.99995L25.9875 14.4287L26.0012 14.4412L26 25.9999Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-housesimple.svg
// module id = eJ2W
// module chunks = 84